import { observer } from 'mobx-react-lite';
import { Resource, Texture } from 'pixi.js';
import { Container, Sprite } from '@pixi/react';

export const JackPotNumbersItemSymbol: React.FC<{ image: Texture<Resource>, containerName: string }> = observer(({
  image,
  containerName,
}) => {
  return (
    <Container  {...({ name: containerName } as any)}>
      <Sprite texture={image} scale={0.5} anchor={0.5} />
    </Container>
  );
});
